import { useTheme } from "@mui/material";
import DSAppBar from "./system-design/DSAppBar";
import DSBox from "./system-design/DSBox";
import GreetLogo from "./system-design/GreetLogo";
import { KLYDO_BLACK } from "../consts/colors";
import Terms from "./Terms";

const TermsPage = () => {
  const { palette } = useTheme();

  return (
    <DSBox
      sx={{
        backgroundColor: palette.background.default,
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <DSAppBar
        onClick={() => {
          window.location.href = "https://www.klydoclock.com/";
        }}
        color="transparent"
        sx={{
          cursor: "pointer",
          paddingTop: { xs: 3, md: 5 },
          display: "flex",
          justifyContent: "center",
          textAlign: "center",
          alignItems: "center",
          boxShadow: "none",
        }}
      >
        <GreetLogo color={KLYDO_BLACK} />
      </DSAppBar>
      <DSBox
        sx={{
          flex: 1,
          overflowY: "auto",
          padding: { xs: 2, md: 4 },
          maxWidth: "900px",
          margin: "0 auto",
          width: "100%",
        }}
      >
        <Terms />
      </DSBox>
    </DSBox>
  );
};

export default TermsPage;
